<script>
import { Drawer } from 'element-ui';

export default {
  extends: Drawer,
};
</script>

<style lang="scss" scoped>
.el-drawer__header {
  padding: 12px 16px;
  margin-bottom: 12px;
  border-bottom: 1px solid $--border-color-base;

  @media only screen and (max-width: $--xs - 1) {
    padding-top: 8px;
    padding-bottom: 8px;
  }
}

.el-drawer--rounded {
  &.btt {
    box-shadow: none;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
}
</style>
